import { render } from "./AddUserPage.vue?vue&type=template&id=c2df89e2&scoped=true"
import script from "./AddUserPage.vue?vue&type=script&lang=js"
export * from "./AddUserPage.vue?vue&type=script&lang=js"

import "./AddUserPage.vue?vue&type=style&index=0&id=c2df89e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2df89e2"]])

export default __exports__